import moment from "moment-timezone";
import { humanizeLoanTypeName } from "@eave/shared/types/api";

// values rounded on backend; to pad strings with trailing zeroes as needed
export const decimalToFivePlaces = (d: string): string => Number(d).toFixed(5);
export const decimalToThreePlaces = (d: string): string => Number(d).toFixed(3);

export const nameToTitle = (name: string) => humanizeLoanTypeName[name] || name; // e.g., "high_balance"

export const timestampParse = (ts: string) => moment(ts).tz("America/Los_Angeles");
export const timestampToDate = (ts: string): string => timestampParse(ts).format("MM/DD/YYYY");

// Humanizes a timestamp, ex. "Last updated 04/13/2020 - 7:56am PDT"
export const timestampToLastUpdatedStr = (ts: string): string => {
  const m = timestampParse(ts);

  const d = m.format("MM/DD/YYYY");
  const t = m.format("h:mma z");

  return `Last updated ${d} - ${t}`;
};
